<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="page-title">LOA Collection Report</h3>
                </div>
            </div>
        </div>
        <!-- /Page Header -->

        <!-- Filter -->
        <div class="row mt-2"></div>
        <div class="row align-items-center mt-2">
            <div class="col-md-2 left-title">Company</div>
            <div class="col-md-4 pl-md-0">
                <select class="custom-select" v-model="company">
                    <option value="">-- Please Select --</option>
                    <option v-for="(item, i) in companies" :key="i" :value="item">
                        {{ item }}
                    </option>
                </select>
            </div>
            <div class="col-md-2 ml-md-4 right-title">Leave Reason<br />(Corporate)</div>
            <div class="col-md-4 pl-md-0">
                <select class="custom-select" v-model="leaveReasonId">
                    <option value="">All</option>
                    <option v-for="(item, i) in leaveReasons" :key="item.Id" :value="item.Id">
                        {{ item.Reason }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row align-items-center mt-2">
            <div class="col-md-2 left-title">Year</div>
            <div class="col-md-4 pl-md-0">
                <select class="custom-select" v-model="year">
                    <option value="">All</option>
                    <option v-for="year in years" :key="year" :value="year">
                        {{ year }}
                    </option>
                </select>
            </div>
            <div class="col-md-2 ml-md-4 right-title">Category</div>
            <div class="col-md-4 pl-md-0">
                <select class="custom-select" v-model="category">
                    <option v-for="(item, i) in categories" :key="item.CategoryCode" :value="item.CategoryCode">
                        {{ item.CategoryName }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row align-items-center mt-2">
            <div class="col-md-2 left-title">Employee Name/ID</div>
            <div class="col-md-4 pl-md-0">
                <Select2 v-model="userId" :options="employees" />
            </div>
            <div class="col-md-2 ml-md-4 right-title">Classification/<br />Job Grade</div>
            <div class="col-md-4 pl-md-0">
                <select class="custom-select" v-model="jobGrade">
                    <option value="">All</option>
                    <option v-for="(item, i) in jobGrades" :key="item" :value="item">
                        {{ item }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row align-items-center mt-2">
            <div class="col-md-2 left-title">Leave Name</div>
            <div class="col-md-4 pl-md-0">
                <select class="custom-select" v-model="leaveCode">
                    <option value="">All</option>
                    <option v-for="leave in leaves" :key="leave.Code" :value="leave.Code">
                        {{ leave.Name }}
                    </option>
                </select>
            </div>
            <div class="col-md-1 ml-md-4" style="max-width: fit-content">
                <button class="btn btn-primary" @click="getLoaCollectionReport">
                    Search
                </button>
            </div>
            <div class="col-md-3">
                <form :action="backendUrl + '/LoaCollectionExcelReport/ExportExcel'" method="POST">
                    <input type="hidden" name="Company" :value="company" />
                    <input type="hidden" name="Year" :value="year" />
                    <input type="hidden" name="UserId" :value="userId" />
                    <input type="hidden" name="LeaveCode" :value="leaveCode" />
                    <input type="hidden" name="LeaveReasonId" :value="leaveReasonId" />
                    <input type="hidden" name="Category" :value="category" />
                    <input type="hidden" name="JobGrade" :value="jobGrade" />
                    <input type="hidden" name="Token" :value="token" />
                    <button type="submit" class="btn btn-primary">
                        <img width="20px" height="20px" class="mr-1" src="../../assets/excel.png" />Export to Excel
                    </button>
                </form>
            </div>
        </div>
        <!-- /Filter -->

        <!-- Pagination -->
        <div class="row mt-4 align-items-center" v-if="records && records.length">
            <div class="col-md-6">
                Show
                <select class="custom-select" v-model="paging.SizePerPage" style="width: 5em">
                    <option v-for="item in paging.Sizes" v-bind:key="item" v-bind:value="item">
                        {{ item }}
                    </option>
                </select>
                entries
            </div>
        </div>
        <!-- /Pagination -->

        <!-- Result Empty -->
        <div class="mt-4" v-if="records && records.length == 0">
            <div class="col-12 no-record">
                {{ noRecordText }}
            </div>
        </div>
        <!-- /Result Empty -->

        <!-- Table List -->
        <div class="row mt-2" v-if="records && records.length">
            <div class="col-md-12">
                <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
                    <table class="table table-bordered custom-table mb-0">
                        <thead class="thead-light">
                            <tr>
                                <th>Employee ID</th>
                                <th>Last Name</th>
                                <th>First Name</th>
                                <th>Hire Date</th>
                                <th>Exit Date</th>
                                <th>Country</th>
                                <th class="text-center">Leave Start Date<br />(MM/DD/YYYY)</th>
                                <th class="text-center">Leave End Date<br />(MM/DD/YYYY)</th>
                                <th># of LOA Days</th>
                                <th>Leave Reason</th>
                                <th style="text-align: center">
                                    Is this a Statuatory Leave<br />exempt from Proration?
                                </th>
                                <th>Local Leave Name</th>
                                <th>Comments</th>
                                <th style="text-align: center">
                                    # of LOA Days subjected to pro-ration<br />(Total LOA > 30 days)
                                </th>
                                <th>Calculation Type</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in records" :key="i">
                                <td :class="!item.EmployeeID ? 'row-total' : ''">{{ item.EmployeeID }}</td>
                                <td :class="!item.EmployeeID ? 'row-total' : ''">{{ item.LastName }}</td>
                                <td :class="!item.EmployeeID ? 'row-total' : ''">{{ item.FirstName }}</td>
                                <td :class="!item.EmployeeID ? 'row-total' : ''">{{ item.HireDateDisplay }}</td>
                                <td :class="!item.EmployeeID ? 'row-total' : ''">{{ item.ExitDateDisplay }}</td>
                                <td :class="!item.EmployeeID ? 'row-total' : ''">{{ item.Country }}</td>
                                <td :class="!item.EmployeeID ? 'row-total text-center' : 'text-center'">
                                    {{ item.LeaveStartDateDisplay }}
                                </td>
                                <td :class="!item.EmployeeID ? 'row-total text-center' : 'text-center'">
                                    {{ item.LeaveEndDateDisplay }}
                                </td>
                                <td>{{ item.NumberOfLoaDays }}</td>
                                <td :class="!item.EmployeeID ? 'row-total' : ''">{{ item.LeaveReason }}</td>
                                <td :class="!item.EmployeeID ? 'row-total' : ''">{{ item.ProrationImpact }}</td>
                                <td :class="!item.EmployeeID ? 'row-total' : ''">{{ item.LeaveName }}</td>
                                <td :class="!item.EmployeeID ? 'row-total' : ''"></td>
                                <td :class="!item.EmployeeID ? 'row-total' : ''">
                                    {{ item.NumberOfLoaDaysSubjectedToProration }}
                                </td>
                                <td :class="!item.EmployeeID ? 'row-total' : ''">{{ item.CalculationType }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- /Table List -->

        <!--Pagination -->
        <div class="row mb-4" v-if="records && records.length">
            <div class="col-md-6 col-lg-6 col-sm-6 my-auto text-lg-left text-center">
                Showing
                {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
                to
                {{
                    paging.CurrentPage * paging.SizePerPage -
                    paging.SizePerPage +
                    records.length
                }}
                of {{ totalRecords }} entries
            </div>

            <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
                <div class="navbar justify-content-end">
                    <button v-on:click="first()" v-if="paging.CurrentPage != 1" class="btn btn-white">
                        First
                    </button>
                    <button v-on:click="prev()" class="btn btn-white ml-1 mr-3" v-if="paging.CurrentPage > 1">
                        Prev
                    </button>
                    Page
                    <input class="form-control form-control-sm mx-1" type="number" step="1" min="1"
                        :max="paging.TotalPage" v-model="paging.CurrentPage" @change="onCurrentPageChange($event)"
                        style="width: 4rem" />

                    <span>of {{ paging.TotalPage }}</span>
                    <button v-on:click="next()" class="btn btn-white ml-3 mr-1"
                        v-if="paging.CurrentPage < paging.TotalPage">
                        Next
                    </button>
                    <button v-on:click="last()" v-if="paging.CurrentPage != paging.TotalPage" class="btn btn-white">
                        Last
                    </button>
                </div>
            </div>
        </div>
        <!--/Pagination -->
    </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
import Select2 from "v-select2-component";
export default {
    components: { Select2 },
    data() {
        return {
            records: [],
            noRecordText: config.NO_RECORD_TEXT,
            //filter
            companies: [],
            company: "",
            years: [],
            year: "",
            employees: [],
            userId: "00000000-0000-0000-0000-000000000000",
            leaves: [],
            leaveCode: "",
            leaveReasons: [],
            leaveReasonId: "",
            categories: [],
            category: "REG",
            jobGrades: [],
            jobGrade: "",
            //for pagination
            paging: {
                Search: "",
                CurrentPage: 1,
                TotalPage: "",
                SizePerPage: 100,
                Sizes: [5, 10, 20, 100],
                SortBy: "",
            },
            totalRecords: "",
        };
    },
    computed: {
        token() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Token;
        },
        role() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Role;
        },
        isManager() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.IsManager ? data.IsManager : false;
        },
        backendUrl() {
            return this.$backendUrl;
        },
    },
    watch: {
        "paging.SizePerPage": function (val, oldVal) {
            this.paging.CurrentPage = 1;
            this.getLoaCollectionReport();
        },
        "paging.CurrentPage": function (val, oldVal) {
            if (val > this.paging.TotalPage) {
                this.paging.CurrentPage = this.paging.TotalPage;
            }
        },
        company(val) {
            this.getLoaCollectionReportSelection();
        },
    },
    methods: {
        //filter
        getLoaCollectionReportSelection() {
            let param = {
                Token: this.token,
                Company: this.company
            };
            API.getLoaCollectionReportSelection(param)
                .then((response) => {
                    if (response.data.success) {
                        this.companies = response.data.companies;
                        this.leaves = response.data.leaves;
                        response.data.employees.unshift({
                            id: "00000000-0000-0000-0000-000000000000",
                            text: "All",
                        });
                        this.employees = response.data.employees;
                        this.leaveReasons = response.data.leaveReasons;
                        this.categories = response.data.categories;
                        this.jobGrades = response.data.jobGrades;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getYears() {
            let date = new Date();
            let minYear = date.getFullYear() - 2;
            this.years = [];
            for (let year = date.getFullYear(); year > minYear; year--) {
                this.years.push(year);
            }
        },
        //records
        getLoaCollectionReport() {
            let param = {
                Token: this.token,
                Search: this.paging.Search,
                CurrentPage: this.paging.CurrentPage,
                TotalPage: this.paging.TotalPage,
                SizePerPage: this.paging.SizePerPage,
                SortBy: this.paging.SortBy,
                Company: this.company,
                Year: this.year,
                UserId: this.userId,
                LeaveCode: this.leaveCode,
                LeaveReasonId: this.leaveReasonId,
                Category: this.category,
                JobGrade: this.jobGrade
            };
            this.$store.state.isLoading = true;
            API.getLoaCollectionReport(param)
                .then((response) => {
                    if (response.data.success) {
                        this.records = response.data.record;
                        this.totalRecords = response.data.total;
                        this.paging.TotalPage = response.data.pageCount;
                        if (this.paging.CurrentPage > this.paging.TotalPage) {
                            this.paging.CurrentPage = 1;
                        }
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                    this.$store.state.isLoading = false;
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },

        //pagination
        onCurrentPageChange(event) {
            let currentPage = event.target.value;
            if (currentPage < 1) {
                currentPage = 1;
            }
            this.paging.CurrentPage = parseInt(currentPage);
            this.getLoaCollectionReport();
        },
        first() {
            this.paging.CurrentPage = 1;
            this.getLoaCollectionReport();
        },
        prev() {
            this.paging.CurrentPage -= 1;
            this.getLoaCollectionReport();
        },
        next() {
            this.paging.CurrentPage += 1;
            this.getLoaCollectionReport();
        },
        last() {
            this.paging.CurrentPage = this.paging.TotalPage;
            this.getLoaCollectionReport();
        },
    },
    created() {
        this.getLoaCollectionReportSelection();
        this.getYears();
        // this.getLoaCollectionReport();
    }
}
</script>

<style scoped>
.left-title {
    max-width: 180px;
}

.right-title {
    max-width: 140px;
    line-height: 18px;
}

.table {
    word-spacing: -3px;
}

.row-total {
    background-color: #dee2e6;
}
</style>


// WEBPACK FOOTER //
// src/components/Leave/LoaCollectionReport.vue